interface PageHeaderProps {
  mainHeaderText: string;
  subHeaderText?: string;
}

/**
 * The PageHeader component provides a consistent display the main header on a page
 *
 * @param {object} props
 *   @param {string} props.mainHeaderText - The header text
 *   @param {string} props.subHeaderText - Sub-text that will show beside the main header
 * @returns {JSX.Element}
 **/
const PageHeader: React.FC<PageHeaderProps> = ({
  mainHeaderText,
  subHeaderText,
}) => (
  <div data-testid="PageHeader">
    <div className="flex flex-col sm:flex-row items-start sm:items-center max-w-7xl py-6 sm:py-10">
      <h1 className="text-3xl font-bold pr-6">{mainHeaderText}</h1>
      <p className="text-md sm:border-l-2 border-[#6E6A8D] sm:pl-6 sm:order-last">
        {subHeaderText}
      </p>
    </div>
  </div>
);

export default PageHeader;
